import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../auth/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent {
  model: any = {};
  loading = false;
  error = '';

  constructor(private loginService: AuthenticationService, private router: Router) {
    document.querySelector('body').className = 'login-page';
    this.redirectIfLoggedIn();
  }

  redirectIfLoggedIn():void {
    if (this.loginService.hq) {
      document.querySelector('body').className = '';
      this.router.navigate(['hq']);
    } else if (this.loginService.store) {
      document.querySelector('body').className = '';
      this.router.navigate(['store']);
    }
  }

  login() {
    this.loginService.login(this.model.username, this.model.password)
      .subscribe(result => {
        if (result === true) {
          this.redirectIfLoggedIn();
        } else {
          this.error = 'Username or password is incorrect';
          this.loading = false;
        }
      });
  }


}



// WEBPACK FOOTER //
// /app/src/app/shared/login/login/login.component.ts